import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { IsUUID, ValidateNested } from 'class-validator';
import { LineItemRequest } from './LineItemRequest';
/**
 * A request for a single part of a multi-day order
 */
export class OrderRequest {
    constructor(id, lineItem) {
        this.id = id;
        this.lineItem = lineItem;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], OrderRequest.prototype, "id", void 0);
__decorate([
    ValidateNested(),
    Serialize(),
    __metadata("design:type", LineItemRequest)
], OrderRequest.prototype, "lineItem", void 0);
